import  React from 'react'
import LanguageSwitcher from "../../../components/languageSwitcher";
import {Img} from "../../../components";
import ChipsContainer from "../../../components/HeaderButton";

export default function Header () {
    return (
        <div className="px-6 pt-10 container-xs">
            <div className="justify-between">
                <div className="flex items-center justify-between">
                    <Img
                        src="/images/logo_header.svg"/>
                    <div className="pr-[90px]">
                    <ChipsContainer/>
                    </div>
                    <LanguageSwitcher/>
                </div>
            </div>
        </div>
    )
}